import { render, staticRenderFns } from "./inbound-sms-rate-widget.vue?vue&type=template&id=2b423c2b"
import script from "./inbound-sms-rate-widget.vue?vue&type=script&lang=js"
export * from "./inbound-sms-rate-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports